<template>
  <div>
    <loginbox></loginbox>
    <div class="tit_d">
      <span>> 首页 - 出售账号 - <span class="blue">详细资料</span></span>
    </div>
    <detailbox :title="'活动详情'" :info="info"></detailbox>
    <div class="box_list">
      <div class="title">
        <div class="tab_lf">
          <span class="red-icon"></span>
          <span>会员详细资料</span>
        </div>
      </div>
      <ul class="two_ul" v-if="detail">
        <li class="two_li">
          <div class="left_p">
            <span class="red_x">*</span>
            会员帐号
          </div>
          <div class="right_p">
            {{detail.account}}
          </div>
        </li>
        <template v-if="sale_extend == 1">
          <li class="two_li">
            <div class="left_p">
              VIP等级
            </div>
            <div class="right_p">
              {{Number(detail.vip_level) || 0}}
            </div>
          </li>
          <li class="two_li">
            <div class="left_p">
              电子等级
            </div>
            <div class="right_p">
              {{Number(detail.e_level)}}元
            </div>
          </li>
          <li class="two_li">
            <div class="left_p">
              真人等级
            </div>
            <div class="right_p">
              {{Number(detail.r_level) || 0}}元
            </div>
          </li>
          <li v-if="isShow.levelSalary" class="two_li">
            <div class="left_p">
              电子晋级礼金
            </div>
            <div class="right_p">
              {{Number(detail.e_up_reward)}}元
            </div>
          </li>
          <li v-if="isShow.weekSalary" class="two_li">
            <div class="left_p">
              电子周俸禄
            </div>
            <div class="right_p">
              {{Number(detail.e_week_reward) || 0}}元
            </div>
          </li>
          <li v-if="isShow.monthSalary" class="two_li">
            <div class="left_p">
              电子月俸禄
            </div>
            <div class="right_p">
              {{Number(detail.e_month_reward) || 0}}元
            </div>
          </li>
          <li v-if="isShow.levelSalary" class="two_li">
            <div class="left_p">
              真人晋级礼金
            </div>
            <div class="right_p">
              {{Number(detail.r_up_reward) || 0}}元
            </div>
          </li>
          <li v-if="isShow.monthSalary" class="two_li">
            <div class="left_p">
              真人月俸禄
            </div>
            <div class="right_p">
              {{Number(detail.r_month_reward) || 0}}元
            </div>
          </li>
          <li class="two_li">
            <div class="left_p">
              电子棋牌累计有效投注
            </div>
            <div class="right_p">
              {{Number(detail.e_bet_amount) || 0}}元
            </div>
          </li>
          <li class="two_li">
            <div class="left_p">
              真人累计有效投注
            </div>
            <div class="right_p">
              {{Number(detail.r_bet_amount) || 0}}元
            </div>
          </li>
        </template>
        <template v-else>
          <li class="two_li">
            <div class="left_p">
              等级
            </div>
            <div class="right_p">
              {{Number(detail.e_level)}}
            </div>
          </li>
          <li v-if="isShow.levelSalary" class="two_li">
            <div class="left_p">
              等级礼金
            </div>
            <div class="right_p">
              {{Number(detail.e_up_reward)}}元
            </div>
          </li>
          <li class="two_li" v-if="isShow.weekSalary">
            <div class="left_p">
              周俸禄
            </div>
            <div class="right_p">
              {{Number(detail.e_week_reward)}}元
            </div>
          </li>
          <li class="two_li" v-if="isShow.monthSalary">
            <div class="left_p">
              月俸禄
            </div>
            <div class="right_p">
              {{Number(detail.e_month_reward)}}元
            </div>
          </li>
        </template>
        <li class="two_li">
          <div class="left_p">
            一口价
          </div>
          <div class="right_p">
            {{Number(detail.sale_price)}}元
          </div>
        </li>
        <li class="two_li">
          <div class="left_p">
            发布时间
          </div>
          <div class="right_p">
            {{detail.created_at*1000 | formatDate}}
          </div>
        </li>
        <li class="two_li">
          <div class="left_p">
            成交时间
          </div>
          <div class="right_p">
            <span v-if="detail.deal_at==0">-</span>
            <span v-else>{{detail.deal_at*1000 | formatDate}}</span>
          </div>
        </li>
      </ul>
      <div class="btn_three">
        <span class="btn_th yell" @click="handleBuy(1)">我要买</span>
        <span class="btn_th red" @click="handleBuy(2)">我要出价</span>
        <router-link tag="span" class="btn_th blue" :to="'/sellpage'">我要卖</router-link>
      </div>
    </div>
    <div class="bar"></div>
  </div>
</template>

<script>
  import loginbox from '@/components/common/loginbox/loginbox'
  import detailbox from '@/components/common/detailbox/detailbox'
  import { saleResource, configResource } from '@/resource/resource'
  import {formatDate} from '@/common/js/common'
  import {mapState} from 'vuex'
  const ERR_OK = 0
  export default {
    name: 'detail',
    data () {
      return {
        detail: null,
        info: null,
        sale_extend: ''
      }
    },
    computed: {
      ...mapState(['config_info']),
      isShow() {
        const info = this.config_info ? this.config_info : {}
        const weekSalary = Number(info.week_salary_status) === 1
        const monthSalary = Number(info.month_salary_status) === 1
        const levelSalary = Number(info.finance_salary_status) === 1
        return { weekSalary, monthSalary, levelSalary }
      }
    },
    created () {
      this.sale_extend = localStorage.getItem('sale_extend')
      this.getDetail()
      this.scroll()
      if (!this.config_info.buy_info) {
        this.getConfig()
      } else {
        this.info = this.config_info.buy_info
      }
    },
    mounted () {
    },
    methods: {
      scroll () {
        setTimeout(() => {
          this.$emit('bscroll')
        }, 20)
      },
      getDetail () {
        saleResource.detail({ id: Number(this.$route.params.id) }).then(res => {
          res = res.body
          if (res.errcode === ERR_OK) {
            this.detail = res.data
          }
        })
      },
      handleBuy (num) {
        this.$emit('funBuy', this.detail, num)
      },
      getConfig () {
        configResource.config({ config: 'buy_info' }).then(response => {
          response = response.body
            if (response.errcode === ERR_OK) {
              this.config_info.buy_info = response.data.buy_info
              this.info = this.config_info.buy_info
            }
        })
      }
    },
    filters: {
      formatDate(time) {
        let date = new Date(time)
        return formatDate(date, 'yyyy-MM-dd hh:mm')
      }
    },
    components: {
      loginbox,
      detailbox
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .bar
    height 0.2rem
    width 100%
  .tit_d
    height 0.8rem
    line-height 0.8rem
    padding-left 0.28rem
    font-size 0.28rem
    color #222
    background-color #fff
    .blue
      color $blue
  .box_list
    margin-top 0.2rem
    color $c-b1
    font-size $fz-t3
    .title
      height 0.8rem
      line-height @height
      font-size $fz-t3
      color $c-b1
      width 100%
      background-color #fff
      display flex
      justify-content space-between
      .tab_lf
        display flex
        align-items center
        .red-icon
          display inline-block
          width 0.06rem
          height 0.32rem
          margin 0 0.20rem 0 0.28rem
          background-color $blue
          border-radius 0.02rem
    .two_ul
      .two_li
        display flex
        background-color #fff
        border-top 1px solid #f4f4f4
        height 0.88rem
        align-items center
        .left_p
          flex 0 0 2.6rem
          box-sizing border-box
          padding-left 0.28rem
          .red_x
            color #cd3c29
        .right_p
          flex 1
          padding-right 0.28rem
    .btn_three
      height 1.2rem
      background-color #fff
      margin-top 0.2rem
      color #fff
      display flex
      align-items center
      justify-content space-around
      .btn_th
        display inline-block
        height 0.6rem
        width 2.0rem
        line-height 0.6rem
        text-align center
        font-size 0.32rem
        border-radius 0.1rem
        &.yell
          background-color #f99a24
        &.red
          background-color #cd3c29
        &.blue
          background-color $blue
</style>



// WEBPACK FOOTER //
// src/components/detail/detail.vue